import ReactFlow, { Controls } from "reactflow"
import styled, { ThemeProvider } from "styled-components"
import { Handle } from "reactflow"
import React, { memo } from "react"

import "reactflow/dist/style.css"

const lightTheme = {
    bg: "#fff",
    primary: "#ff0072",

    nodeBg: "#f2f2f5",
    nodeColor: "#222",
    nodeBorder: "#222",
}

const darkTheme = {
    bg: "#000",
    primary: "#ff0072",

    nodeBg: "#343435",
    nodeColor: "#f9f9f9",
    nodeBorder: "#888",
}

const Node = styled.div`
    width: 150px;
    border-radius: 3px;
    padding: 10px;
    font-size: 12px;
    text-align: center;
    border-width: 1px;
    border-style: solid;

    border: 1px solid ${props => (props.selected ? props.theme.primary : props.theme.nodeBorder)};
    background: ${props => props.theme.nodeBg};
    color: ${props => props.theme.nodeColor};
`

const CustomNode = memo(({ data, selected }) => {
    return (
        <Node selected={selected}>
            <Handle type="target" position="left" />
            <div>
                <strong>{data.label}</strong>
            </div>
            <Handle type="source" position="right" />
        </Node>
    )
})

const nodeTypes = {
    custom: CustomNode,
}

const ReactFlowStyled = styled(ReactFlow)`
    background-color: ${props => props.theme.bg};
`

const Timeline = props => {
    const theme = props.theme === "light" ? lightTheme : darkTheme

    return (
        <ThemeProvider theme={theme}>
            <ReactFlowStyled nodes={props.nodes} edges={props.edges} edgeTypes={props.edgeTypes} nodeTypes={nodeTypes}>
                <Controls />
            </ReactFlowStyled>
        </ThemeProvider>
    )
}

export default Timeline
